export default "__VITE_ASSET__CRjSRWHh__"